<template>
    <!-- 虚拟奖品弹窗 -->
    <van-dialog v-model="isVisibility" :show-confirm-button="false" :styles="{top: '100px'}"  >
        <div class="diyModal">
            <div class="diyModalBg" :class="awardObj.bigWheelActivityType == '3' ? 'tiger-modal-bg' : 'other-modal-bg'">
              <img :src="diyModalBg[awardObj.bigWheelActivityType-1]">
            </div>
            <div class="awardContent">
                <div v-if="awardObj.bigWheelActivityType != '3'" class="awardName" :style="{'color': awardObj.bigWheelActivityType == '2' ? '#29231E' : '#2592f7'}">{{awardObj.goodsName || awardObj.rewardName}}</div>
                <div v-else class="tiger-name">{{ awardObj.goodsName || awardObj.rewardName }}</div>
                <img :src="diyModalHead[awardObj.bigWheelActivityType-1]" style="width: 100%;">
                <div style="padding: 10px 20px; display: flex; justify-content: space-between;">
                    <span class="activationCode">{{awardObj.activationCode}}</span>
                    <span v-if="awardObj.bigWheelActivityType != '3'" class="copy" :style="{'color': awardObj.bigWheelActivityType == '2' ? '#B27D13' : '#2592f7'}" v-clipboard:copy="awardObj.activationCode" v-clipboard:success="onCopy"  v-clipboard:error="onError">复制</span>
                    <span v-else v-clipboard:copy="awardObj.activationCode" v-clipboard:success="onCopy" v-clipboard:error="onError" class="tiger-copy">复制</span>
                </div>
                <div v-if="awardObj.singleFlag && awardObj.jumpType === '1'" style="text-align: center; color: #999999; margin: 15px 0 0 0;">点击确认返回Hi荣耀首页</div>
                <!-- <div class="defaultGray" style="font-size: 12px; margin-top: 5px; text-align: center;" v-html="rewardDescri"></div> -->
            </div>
            <div class="diyReceive">
                <div class="diyModalButton" :class="{'blindBoxBtn': awardObj.bigWheelActivityType == '2'}">
                    <img v-if="awardObj.bigWheelActivityType == '1' && !activityObj.extendConfig.awardPopupButtonColor" src="static/runtime/images/magic/award/diyModalButton.png" />
                    <img v-if="awardObj.bigWheelActivityType == '4' && !activityObj.extendConfig.awardPopupButtonColor" src="static/runtime/images/magic/award/diyModalButton.png" />
                    <img v-if="awardObj.bigWheelActivityType == '3' && !activityObj.extendConfig.awardPopupButtonColor" :class="awardObj.bigWheelActivityType == '3' ? 'tiger-btn-img':''" src="static/runtime/images/magic/award/tiger-btn.png" />
                    <div v-if="awardObj.bigWheelActivityType == '1' && activityObj.extendConfig.awardPopupButtonColor" class="diyModalButtonBg" :style=getButtonBgStyle></div>
                    <div v-if="awardObj.bigWheelActivityType == '3' && activityObj.extendConfig.awardPopupButtonColor" class="diyModalButtonBg" :style=getButtonBgStyle></div>
                    <div v-if="awardObj.bigWheelActivityType == '2'" class="diyModalButtonBg" :style=getButtonBgStyle></div>
                    <div class="diyModalButtonText">
                        <div v-if="!awardObj.singleFlag" :class="awardObj.bigWheelActivityType == '3' ? 'tiger-btn': ''" @click="modalCancel(awardObj.extendConfigFlag)">关闭</div>
                        <div v-if="awardObj.singleFlag" :class="awardObj.bigWheelActivityType == '3' ? 'tiger-btn': ''" @click="nextStep(awardObj.jumpUrl,awardObj.jumpType)">{{ modalButtonText }}</div>
                    </div>
                </div>
            </div>
            <div class="diyClose" @click="modalCancel(awardObj.extendConfigFlag)"><van-icon name="close" /></div>
        </div>
    </van-dialog>
</template>


<script>
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import { Dialog, Icon } from 'vant';
Vue.use(VueClipboard)
export default {
    components: {
        [Dialog.Component.name]: Dialog.Component,
        [Icon.name]: Icon,
    },
    props: {
        awardObj: Object,
        activityObj: Object,
        modalButtonText: String
        
    },
    data(){
        return{
            isVisibility: false,
            diyModalBg: [
              'static/runtime/images/magic/award/diyModalBg.png',
              'static/runtime/images/magic/award/awardBg2.png',
              'static/runtime/images/magic/award/tiger-bj.png',
              'static/runtime/images/magic/award/diyModalBg.png',
            ],
            diyModalHead: [
              'static/runtime/images/magic/award/zjjl_tc_bg.png',
              'static/runtime/images/magic/award/awardBg1.png',
              'static/runtime/images/magic/award/tiger-machine-head-bg.png',
              'static/runtime/images/magic/award/zjjl_tc_bg.png',
            ]
        }
    },
    created() {

    },
    mounted() {

    },
    computed: {
        rewardDescri(){
            if(this.awardObj.rewardDescri){
                return this.awardObj.rewardDescri.replace(/↵/g,"<br/>").replace(/\n/g,"<br/>");
            }else{
                return '';
            }
        },
        getButtonBgStyle() {
            return {
                'background': this.activityObj.extendConfig.awardPopupButtonColor || '#ffffff',
            };
        },
    },
    methods:{
        openModel(){
            this.isVisibility=true;
        },
        modalOk(){
            this.isVisibility=false
            // this.$emit("refreshRecord");
        },
        modalCancel(extendConfigFlag){
            this.isVisibility=false;
            if(extendConfigFlag) return;
            // this.$emit("refreshRecord");
        },
        onCopy(){
            this.$utils.tips.message('success', '复制成功！');
        },
        onError(){
            this.$utils.tips.message('error', '复制失败！');
        },
        nextStep(link,type){
            if(type==='9'){
                this.modalCancel(this.awardObj.extendConfigFlag)
            }
            this.$emit('nextStep',link,type);
        }
    },
}
</script>

<style lang="scss" scoped>
    .van-dialog{
        width: 100%;
        overflow: initial;
        background-color: transparent;
        /deep/ .van-dialog__content {
            margin: 0;
            padding: 0;
            width: 100%;
            height: 111vh;
            display: flex;
            align-items: center;
            justify-content: center;

            .diyModal {
                width: 320px;
                // max-width: 694px;
                height: auto;
                margin: auto;
                min-height: 245px;
                padding-bottom: 125px;
                position: relative;
                z-index: 10;
                .tiger-modal-bg {
                }
                .other-modal-bg {
                    img {
                    height: 210px;
                    }
                }
                .diyModalBg {
                    width: 100%;
                    height: 210px;
                    border-radius: 20px;
                    position: absolute;
                    bottom:0;
                    z-index: -1;
                    overflow: hidden;
                    &::before {
                      content: "";
                      width: 98%;
                      height: 150px;
                      position: absolute;
                      bottom: 1px;
                      background: #ffffff;
                      border-radius: 26px;
                    }
                    img {
                      width: 100%;
                      position: absolute;
                      bottom: -1px;
                    }
                }
                .awardContent {
                    width: 95%;
                    min-height: 120px;
                    margin: 0 2.5%;
                    background: #FFFFFF;
                    text-align: center;
                    border-radius: 20px 20px 0 0;
                    .tiger-name {
                        font-family: HYQiHei-FZS;
                        font-size: 20px;
                        padding: 26px 0 0;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        color: #29231E;
                        font-weight: 400;
                    }
                    .awardName {
                        color: #2592F7;
                        font-size: 20px;
                        padding: 26px 10px 0;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                    .tiger-copy {
                        font-family: HYQiHei-FZS;
                        color: #29231E;
                        background: #F2F7FF;
                        text-align: center;
                        padding: 5px 10px;
                        border-radius: 15px;
                        font-size: 12px;
                        margin: 0 10px 0 0;
                        font-weight: 400;
                    }
                    .copy {
                        color: #2592F7;
                        background: #F2F7FF;
                        text-align: center;
                        padding: 5px 10px;
                        border-radius: 15px;
                        font-size: 12px;
                        margin: 0 10px 0 0;
                    }
                    .defaultGray {
                        color: #666666;
                    }
                    .activationCode {
                        max-width: 80%;
                        display: inline-block;
                        vertical-align: middle;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        flex: 1;
                    }
                }
                .tiger-btn {
                    font-family: HYQiHei-EES;
                    color: #D7324C;
                    font-size: 18px;
                }
                .diyReceive {
                    width: 100%;
                    height: 140px;
                    position: absolute;
                    bottom: 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .tiger-btn-img {
                        width: 90% !important;
                        height: 80% !important;
                    }
                    .diyModalButton, .blindBoxBtn {
                        width: 200px;
                        height: 45px;
                        margin-top: 54px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-family: PingFangSC-Medium;
                        font-size: 18px;
                        color: #FFFFFF;
                        position: relative;
                        img, .diyModalButtonBg {
                            width: 100%;
                            height: 100%;
                            position: absolute;
                        }
                        .diyModalButtonBg {
                          background: #FFFFFF;
                          border-radius: 36px;
                        }
                        .diyModalButtonText {
                            width: 100%;
                            height: 100%;
                            position: absolute;
                            div {
                                width: 100%;
                                height: 100%;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                            }
                        }
                    }

                    .blindBoxBtn {
                      color: #B27D13 !important;
                      font-size: 16px;
                      height: 36px;
                    }
                }
                .diyClose {
                    width: 30px;
                    height: 30px;
                    font-size: 36px;
                    position: absolute;
                    left: 50%;
                    transform: translate(-50%, 0);
                    bottom: -50px;
                    z-index: 10000;
                    color: #FFFFFF;
                }
            }
        }
    }

</style>




// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/modal/virtualAwardModal.vue